/**
 * TB paths that only redirect to a child (no page of their own).
 * Linking them in Nimbus would navigate then land back on the same leaf
 * (e.g. /account → /account/profile), unlike standalone TB where that
 * click feels like a no-op.
 */
const REDIRECT_ONLY_BREADCRUMB_PATHS = new Set(["/account", "/profile"]);

export const isNavigableBreadcrumbPath = (
  path: string | undefined
): boolean => {
  if (!path) return false;
  const cleanPath = path.split("?")[0] ?? "";
  if (!cleanPath) return false;
  return !REDIRECT_ONLY_BREADCRUMB_PATHS.has(cleanPath);
};
